/**
 * 员工管理 - 枚举定义
 *
 * 职责：定义员工相关的枚举类型
 * 来源：backend/app/Models/Employee.php
 *
 * @module types/employee/enums
 * @see backend/app/Models/Employee.php - 枚举常量定义
 *
 * @注意事项
 * 1. 枚举值必须与后端完全一致（包括大小写）
 * 2. 不要修改枚举值，只能新增
 * 3. 废弃的枚举值标记 @deprecated 但不要删除
 *
 * @更新时机
 * - 后端新增枚举值时
 * - 后端修改枚举值时
 * - 枚举说明需要更新时
 *
 * @验证方式
 * - 对照 Employee.php 中的常量定义
 * - 确保枚举值完全匹配
 * - 确保所有枚举都有中文注释
 *
 * @last-updated 2025-10-18
 * @last-verified 2025-10-18
 */

/**
 * 性别
 */
export enum Gender {
  /** 未知 */
  UNKNOWN = 0,
  /** 男 */
  MALE = 1,
  /** 女 */
  FEMALE = 2,
}

/**
 * 婚姻状况
 */
export enum MaritalStatus {
  /** 未婚 */
  SINGLE = 1,
  /** 已婚 */
  MARRIED = 2,
  /** 离异 */
  DIVORCED = 3,
  /** 丧偶 */
  WIDOWED = 4,
}

/**
 * 在职状态
 */
export enum EmploymentStatus {
  /** 在职 */
  ACTIVE = 1,
  /** 离职 */
  RESIGNED = 2,
  /** 停职 */
  SUSPENDED = 3,
}

/**
 * 状态
 */
export enum EmployeeStatus {
  /** 禁用 */
  DISABLED = 0,
  /** 启用 */
  ENABLED = 1,
}

